export default __webpack_public_path__ + "static/media/Samba Bank Cheque.986b6010.jpg";